<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-alert"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingAlert"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="9"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|max:250"
                      name="alert.description"
                    >
                      <v-text-field
                        v-model="alert.description"
                        :error-messages="errors"
                        color="secondary"
                        :label="$t('fields.alert.description')"
                        outlined
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="alert.active"
                    >
                      <v-switch
                        v-model="alert.active"
                        class="mx-2"
                        :label="$t('fields.alert.active')"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="alert.targetId"
                    >
                      <v-select
                        v-model="alert.targetId"
                        :items="targets"
                        item-text="description"
                        item-value="id"
                        :label="$t('fields.alert.targetId')"
                        :error-messages="errors"
                        outlined
                        :loading="loadingTargets"
                        disabled
                        @change="getTargetDevicesByTarget"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="alert.targetDeviceId"
                    >
                      <v-select
                        v-model="alert.targetDeviceId"
                        :items="targetDevices"
                        item-text="description"
                        item-value="id"
                        :label="$t('fields.alert.targetDeviceId')"
                        :error-messages="errors"
                        outlined
                        :loading="loadingTargetDevices"
                        disabled
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="alert.contactId"
                    >
                      <v-select
                        v-model="alert.contacts"
                        :items="contacts"
                        item-text="name"
                        item-value="id"
                        :label="$t('fields.alert.contacts')"
                        :error-messages="errors"
                        outlined
                        multiple
                        :loading="loadingContacts"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="alert.type"
                    >
                      <v-select
                        v-model.number="alert.periodicity"
                        :items="periodicities"
                        item-text="text"
                        item-value="value"
                        :label="$t('fields.alert.periodicity')"
                        :error-messages="errors"
                        outlined
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row v-if="alert.type == 'Temp'">
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="alert.alertTypeTemp"
                    >
                      <v-radio-group
                        v-model="alert.alertTypeTemp"
                        :mandatory="true"
                        :error-messages="errors"
                      >
                        <template v-slot:label>
                          <div>{{ $t('fields.alert.alertType') }}</div>
                        </template>
                        <v-radio
                          :label="$t('fields.alert.min')"
                          value="Min"
                        />
                        <v-radio
                          :label="$t('fields.alert.max')"
                          value="Max"
                        />
                        <v-radio
                          :label="$t('fields.alert.isMinMax')"
                          value="MinMax"
                        />
                      </v-radio-group>
                    </validation-provider>
                  </v-col>
                  <!-- <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="numeric|required_if:alert.alertTypeTemp,Min,MinMax"
                          name="alert.min"
                        >
                          <v-text-field
                            v-model.number="alert.min"
                            :label="$t('fields.alert.min')"
                            :error-messages="errors"
                            :disabled="alert.alertTypeTemp === 'Max' "
                          />
                        </validation-provider>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="numeric|required_if:alert.alertTypeTemp,Max,MinMax"
                          name="alert.max"
                        >
                          <v-text-field
                            v-model.number="alert.max"
                            :label="$t('fields.alert.max')"
                            :error-messages="errors"
                            :disabled="alert.alertTypeTemp === 'Min' "
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col> -->
                </v-row>
                <v-row v-if="alert.type == 'Tank'">
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="alert.alertTypeTank"
                    >
                      <v-radio-group
                        v-model="alert.alertTypeTank"
                        :mandatory="true"
                        :error-messages="errors"
                      >
                        <template v-slot:label>
                          <div>{{ $t('fields.alert.alertType') }}</div>
                        </template>
                        <v-radio
                          :label="$t('fields.alert.min')"
                          value="Min"
                        />
                        <!-- <v-radio
                          :label="$t('fields.alert.isMoved')"
                          value="IsMoved"
                        /> -->
                      </v-radio-group>
                    </validation-provider>
                  </v-col>
                  <!-- <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row>
                      <v-col
                        v-if="alert.alertTypeTank == 'IsMoved'"
                        cols="12"
                        md="6"
                      >
                        <v-menu
                          ref="menu"
                          v-model="startTimeMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="alert.startTime"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <validation-provider
                              v-slot="{ errors }"
                              rules="required"
                              name="alert.startTime"
                            >
                              <v-text-field
                                v-model="alert.startTime"
                                rules="required"
                                :label="$t('fields.alert.startTime')"
                                prepend-icon="mdi-clock-outline"
                                readonly
                                :error-messages="errors"
                                v-on="on"
                              />
                            </validation-provider>
                          </template>
                          <v-time-picker
                            v-if="startTimeMenu"
                            v-model="alert.startTime"
                            full-width
                            :max="alert.endTime"
                            @click:minute="$refs.menu.save(alert.startTime)"
                          />
                        </v-menu>
                      </v-col>
                      <v-spacer />
                      <v-col
                        v-if="alert.alertTypeTank == 'IsMoved'"
                        cols="12"
                        md="6"
                      >
                        <v-dialog
                          ref="dialog"
                          v-model="endTimeModal"
                          :return-value.sync="alert.endTime"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <validation-provider
                              v-slot="{ errors }"
                              rules="required"
                              name="alert.endTime"
                            >
                              <v-text-field
                                v-model="alert.endTime"
                                rules="required"
                                :label="$t('fields.alert.endTime')"
                                prepend-icon="mdi-clock-outline"
                                readonly
                                :error-messages="errors"
                                v-on="on"
                              />
                            </validation-provider>
                          </template>
                          <v-time-picker
                            v-if="endTimeModal"
                            v-model="alert.endTime"
                            full-width
                            :min="alert.startTime"
                          >
                            <v-spacer />
                            <v-btn
                              text
                              color="primary"
                              @click="endTimeModal = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(alert.endTime)"
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                      <v-col
                        v-if="alert.alertTypeTank == 'Min'"
                        cols="12"
                        md="6"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          rules="numeric|required_if:alert.alertTypeTank,Min"
                          name="alert.min"
                        >
                          <v-text-field
                            v-model.number="alert.min"
                            :label="$t('fields.alert.min')"
                            :error-messages="errors"
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col> -->
                </v-row>
                <base-material-alert
                  v-model="showSuccessAlert"
                  color="success"
                  dark
                  dismissible
                >
                  <span class="text-uppercase">{{ $t('Success') }} :</span>
                </base-material-alert>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const contactsRespository = repositoryFactory.get('persons')
  const targetAlertsRespository = repositoryFactory.get('targetAlerts')
  const targetdDevicesRespository = repositoryFactory.get('targetdDevices')
  const targetsRespository = repositoryFactory.get('targets')

  export default {
    inject: ['theme'],
    name: 'AlertCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      alert: { active: true },
      periodicities: [{ text: '5m', value: 5 },
                      { text: '10m', value: 10 },
                      { text: '15m', value: 15 },
                      { text: '30m', value: 30 },
                      { text: '45m', value: 45 },
                      { text: '1h', value: 60 },
                      { text: '1:30h', value: 90 },
                      { text: '2h', value: 120 },
                      { text: '3h', value: 180 },
                      { text: '4h', value: 240 },
                      { text: '5h', value: 300 },
                      { text: '6h', value: 360 },
                      { text: '12h', value: 720 },
                      { text: '24h', value: 1440 }],
      targetDevices: [],
      targets: [],
      contacts: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingAlert: false,
      showSuccessAlert: false,
      formAction: null,
      loadingTargetDevices: false,
      loadingTargets: false,
      loadingContacts: false,
      starOnDateDateMenu: false,
      endOnDateDateMenu: false,
      startTimeMenu: false,
      endTimeModal: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-alert') : this.$t('modify-alert')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingAlert = true
        var id = this.$route.params.id
        targetAlertsRespository.getById(id).then(response => {
          self.loadingAlert = false
          self.alert = Object.assign({}, response.data.data)
          self.getTargetDevicesByTarget()
        }).catch(err => {
          self.loadingAlert = false
          alert(err)
        })
      }

      this.getContacts()
      this.getTargets()
    },
    methods: {
      getTargetDevicesByTarget () {
        var self = this
        self.loadingTargetDevices = true
        targetdDevicesRespository.getTargetDevicesByTarget(self.alert.targetId).then(response => {
          self.targetDevices = response.data.data
          self.loadingTargetDevices = false
        }).catch(err => {
          self.loadingTargetDevices = false
          self.showErrorMessage = true
          self.errorMessage = err
        })

        self.targets.forEach((e) => {
          if (e.id === self.alert.targetId) {
            self.alert.type = (e.typeTargetCode === 'TA' ? 'Tank' : 'Temp')
          }
        })
      },
      getTargets () {
        var self = this
        self.loadingTargets = true
        targetsRespository.getActives().then(response => {
          self.targets = response.data.data
          self.loadingTargets = false
        }).catch(err => {
          self.loadingTargets = false
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      getContacts () {
        var self = this
        self.loadingContacts = true
        contactsRespository.get().then(response => {
          self.contacts = response.data.data
          self.loadingContacts = false
        }).catch(err => {
          self.loadingContacts = false
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      submitForm (scope) {
        var self = this
        var data = {
          data: this.alert,
        }

        if (self.formAction !== 'add') {
          targetAlertsRespository.update(data, this.alert.id).then(response => {
            if (response.data.isValid) {
              self.showSuccessAlert = true
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        } else {
          targetAlertsRespository.add(data).then(response => {
            if (response.data.isValid) {
              self.alert = response.data.data
              self.showSuccessAlert = true
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        }
      },
      goToList () {
        this.$router.push({ name: 'currentAlerts' })
      },
    },
  }
</script>
